import React, { useMemo, useState } from 'react';
import { Navigate, Outlet, useLocation, useRoutes } from 'react-router-dom';
import { toast } from "react-toastify";
import DashboardLayout from './layouts/dashboard';

import Dashboard from './pages/Dashboard';


import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Home from './pages/Home1';
import Policy from './pages/Policy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import ProjectLogin from './pages/ProjectLogin';
import LayoutImageAdmin from './pages/layout/admin/LayoutImageAdmin';
import Services from './pages/services/Services';

import Layoutvideo from './pages/Layoutvideo';
import ProjectsAgent from './pages/ProjectsAgent';
import AdminAgentEditCreate from './pages/layout/admin/AdminAgentCreate';
import AdminAgentList from './pages/layout/admin/AdminAgentList';
import AdminProcurementCreate from './pages/layout/admin/AdminProcurementCreate';
import AdminProcurementList from './pages/layout/admin/AdminProcurementList';
import AdminEditCreate from './pages/layout/admin/AdminEditCreate';
import AdminList from './pages/layout/admin/AdminList';
import AdminProjectList from './pages/layout/admin/AdminProjectList';
import LayoutImageAgent from './pages/layout/agents/LayoutImageAgent';

import LoginPage from './pages/Login/LoginPage';
import AgentEditCreate from './pages/layout/agents/AgentEditCreate';
import AgentList from './pages/layout/agents/AgentList';
import AgentsOffers from './pages/layout/agents/AgentsOffers';
import CustomerOffers from './pages/layout/agents/CustomerOffers';
import EmailBroadcast from './pages/layout/admin/EmailBroadcast';
import ImageTextReplacer from './pages/layout/agents/imgEdit';
import VisitingEdit from './pages/layout/agents/vistingEdit';
import ProcurementList from './pages/layout/agents/ProcurementList';
import ProcurementEdit from './pages/layout/agents/ProcurementEdit';
import ProcurementEditCreate from './pages/layout/procurement/ProcurementEditCreate';
import ProcurementApproval from './pages/layout/agents/ProcurementApproval';
import PaymentRequests from './pages/PaymentRequests';
import ProcurementDashboard from './pages/ProcurementDashboard';

import ForgetPassword from './pages/Login/ForgetPassword';
import OtpVerify from './pages/Login/OtpVerify';
import ResetPassword from './pages/Login/ResetPassword';
import Bankdetails from './pages/layout/admin/Bankdetails';
import { default as ChangePasswordAdmin } from './pages/layout/admin/ChangePassword';
import Commission from './pages/layout/admin/Commission';
import CommissionEditCreate from './pages/layout/admin/CommissionEditCreate';
import CommissionView from './pages/layout/admin/CommissionView';
import { default as ProfileAdmin } from './pages/layout/admin/MyProfile';
import OfferEditCreate from './pages/layout/admin/OfferEditCreate';
import Posters from './pages/layout/admin/Posters';
import Quotations from './pages/layout/admin/Quotations';
import VisitingPoster from './pages/layout/admin/VistingPoster';
import Offers from './pages/layout/admin/offers';
import AgentProjectList from './pages/layout/agents/AgentProjectList';
import AgentofferImages from './pages/layout/agents/AgentofferImages';
import { default as ChangePasswordAgent } from './pages/layout/agents/ChangePassword';
import CheckOutDetails from './pages/layout/agents/CheckOut';
import CustomerofferImages from './pages/layout/agents/CustomerofferImage';
import { default as ProfileAgent } from './pages/layout/agents/MyProfile';
import QuotationsEdit from './pages/layout/agents/QuotationsEdit';
import Wallet from './pages/layout/agents/Wallet';
import AdsCreate from './pages/layout/admin/AdsCreate';
import ProjectEdit from './pages/layout/withoutAuth/ProjectEdit';
import ProjectList from './pages/layout/withoutAuth/ProjectList';
import AgentCreate from './pages/layout/withoutAuth/AgentCreate';
import PaymentSucess from './pages/layout/agents/paymentSucess';
import PaymentDetails from './pages/layout/agents/paymentDetails';
import AdminRoleCreate from './pages/layout/admin/AdminRoleCreate';
import SubscriptionPage from './pages/layout/subscription/SubscriptionPage'
import ProcurementSubscriptionPage from './pages/layout/subscription/ProcurementSubscriptionPage'
import SubscriptionLogout from './pages/layout/subscription/SubscriptionLogout'
import CustomProjectPay from './pages/layout/admin/CustomProjectPay'
import MapList from './pages/layout/admin/map/MapList';
import MapEditCreate from './pages/layout/admin/map/MapEditCreate';
import Map from './pages/layout/admin/map/Map';
import Myqr from './pages/layout/myqr/myqr';
import AgentAprroval from './pages/layout/agents/AgentAprroval';

// Import KYC and Procurement components
import ProcurementCreate from './pages/layout/withoutAuth/ProcurementCreate';
import KYCVerification from './pages/layout/kyc/KYCVerification';
import KYCStatus from './pages/layout/kyc/KYCStatus';
import KYCAdminDashboard from './pages/layout/admin/KYCAdminDashboard';
import LayoutOnboardingRequest from './pages/layout/withoutAuth/LayoutOnboardingRequest';
import LayoutRequestsList from './pages/layout/admin/LayoutRequestsList';
import LayoutRequestApproval from './pages/layout/admin/LayoutRequestApproval';
import ProcurementLayoutRequests from './pages/layout/agents/ProcurementLayoutRequests';
import ProcurementLayoutRequestView from './pages/layout/agents/ProcurementLayoutRequestView';
import ProcurementAdsRequests from './pages/layout/agents/ProcurementAdsRequests';
import ProcurementOnboarding from './pages/layout/withoutAuth/ProcurementOnboarding';
import Analytics from './pages/layout/admin/Analytics';


function LogoOnlyLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}


export default function Router() {
  const [account, setAccount] = useState({});

  const userDetails = sessionStorage.getItem('user_details');
  useMemo(() => {
    setAccount(JSON.parse(userDetails))
  }, [userDetails])

  console.log(account," ")
  const children = [
    { path: 'about', element: <About /> },
    { path: 'home', element: <Home /> },
    { path: 'blog', element: <Blog /> },
    { path: 'contact', element: <Contact /> },
    { path: 'policy', element: <Policy /> },
    { path: 'terms-and-conditions', element: <TermsConditions /> },
    { path: 'refund-policy', element: <RefundPolicy /> },
    { path: 'services', element: <Services /> },
    { path: 'project', element: <ProjectLogin /> },
    { path: 'projectAgent', element: <ProjectsAgent /> },
    { path: 'forgetPassword', element: <ForgetPassword /> },
    { path: 'resetpassword', element: <ResetPassword /> },
    { path: 'projectLayout', element: <ProjectList /> },
    { path: 'AgentCreate/:qr', element: <AgentCreate /> },
    { path: 'ProcurementCreate/:qr', element: <ProcurementCreate /> },
    { path: 'ProcurementOnboarding/:qr', element: <ProcurementOnboarding /> },
    { path: 'projectLayout/:id', element: <ProjectEdit /> },
    { path: 'sample_video', element: <Layoutvideo /> },
    { path: 'login', element: <LoginPage /> },
    { path: 'otp-verify', element: <OtpVerify /> },
    { path: '/', element: <Navigate to="/home" replace /> },
    { path: '*', element: <Navigate to="/home" replace /> },
    { path: 'Map', element: <Map /> },

    

  ]

  const AgentChildren = [
    { path: 'perfectlayout', element: <Dashboard /> },
    { path: 'projectagent', element: <AgentProjectList /> },
    { path: 'agentUser/create', element: <AgentEditCreate /> },
    { path: 'agentUser', element: <AgentList /> },
    { path: 'projectAgent/:id', element: <LayoutImageAgent /> },
    { path: 'checkOutDetails/:id', element: <CheckOutDetails /> },


    { path: 'profile', element: <ProfileAgent /> },
    { path: 'changePassword', element: <ChangePasswordAgent /> },
    { path: 'wallet', element: <Wallet /> },
    { path: 'Customeroffers', element: <CustomerOffers /> },
    { path: 'agentoffers', element: <AgentsOffers /> },
    { path: 'customerofferimages/:id', element: <CustomerofferImages /> },
    { path: 'agentofferimages/:id', element: <AgentofferImages /> },
    { path: 'commission', element: <Commission /> },
    { path: 'commissionview/:id', element: <CommissionView /> },
    { path: 'bankdetails', element: <Bankdetails /> },
    { path: 'imgEdit', element: < Posters /> },
    { path: 'VisitingPoster', element: < VisitingPoster /> },
    { path: 'imagepage/:id', element: < ImageTextReplacer /> },
    { path: 'visiting/:id', element: < VisitingEdit /> },
    { path: 'Quotations', element: < Quotations /> },
    { path: 'QuotationsEdit/:id', element: < QuotationsEdit /> },

    { path: 'paymentsucess/:id', element: < PaymentSucess /> },
    { path: 'paymentdetails', element: < PaymentDetails /> },
    { path: 'CustomProjectPay', element: < CustomProjectPay /> },
    { path: 'Map', element: <Map /> },
    { path: 'Myqr', element: <Myqr /> },
    { path: 'AgentAprroval', element: <AgentAprroval /> },
    { path: 'kyc-verification', element: <KYCVerification /> },
    { path: 'kyc-status', element: <KYCStatus /> },
    { path: 'procurement', element: <ProcurementList /> },
    { path: 'procurement/create', element: <ProcurementEditCreate /> },
    { path: 'procurement/edit/:id', element: <ProcurementEditCreate /> },
    { path: 'procurement/approval/:id', element: <ProcurementApproval /> },
    { path: 'procurement/layout-requests', element: <ProcurementLayoutRequests /> },
    { path: 'procurement/layout-requests/view/:id', element: <ProcurementLayoutRequestView /> },


  ]

  const AdminChildern = [
    { path: 'perfectlayout', element: <Dashboard /> },
    { path: 'analytics', element: <Analytics /> },
    { path: 'procurement-dashboard', element: <ProcurementDashboard /> },
    { path: 'projectadmin', element: <AdminProjectList /> },
    { path: 'projectAdmin/:id', element: <LayoutImageAdmin /> },
    { path: 'adminUser/create', element: <AdminEditCreate /> },
    { path: 'adminUserRole/create', element: <AdminRoleCreate /> },
    { path: 'adminUserRole/:id', element: <AdminRoleCreate /> },
    { path: 'adminUser/:id', element: <AdminEditCreate /> },
    { path: 'adminUser', element: <AdminList /> },
    { path: 'profile', element: <ProfileAdmin /> },
    { path: 'changePassword', element: <ChangePasswordAdmin /> },
    { path: 'adminAgentUser', element: <AdminAgentList /> },
    { path: 'adminAgentUser/create', element: <AdminAgentEditCreate /> },
    { path: 'adminAgentUser/:id', element: <AdminAgentEditCreate /> },
    { path: 'adminProcurementUser', element: <AdminProcurementList /> },
    { path: 'adminProcurementUser/create', element: <AdminProcurementCreate /> },
    { path: 'adminProcurementUser/:id', element: <AdminProcurementCreate /> },
    { path: 'offers/create', element: <OfferEditCreate /> },
    { path: 'offers/:id', element: <OfferEditCreate /> },
    { path: 'offers', element: <Offers /> },
    { path: 'Customeroffers', element: <CustomerOffers /> },
    { path: 'agentoffers', element: <AgentsOffers /> },
    { path: 'customerofferimages/:id', element: <CustomerofferImages /> },
    { path: 'agentofferimages/:id', element: <AgentofferImages /> },
    { path: 'commission', element: <Commission /> },
    { path: 'commission/:id', element: <CommissionEditCreate /> },
    { path: 'commissionview/:id', element: <CommissionView /> },
    { path: 'bankdetails', element: <Bankdetails /> },
    { path: 'imgEdit', element: < Posters /> },
    { path: 'VisitingPoster', element: < VisitingPoster /> },
    { path: 'imagepage/:id', element: < ImageTextReplacer /> },
    { path: 'visiting/:id', element: < VisitingEdit /> },
    { path: 'Quotations', element: < Quotations /> },
    { path: 'QuotationsEdit/:id', element: < QuotationsEdit /> },
    { path: 'paymentdetails', element: < PaymentDetails /> },
    { path: 'MapList', element: < MapList /> }, 
    { path: 'MapEditCreate/:id', element: < MapEditCreate /> },
    { path: 'MapEditCreate/', element: < MapEditCreate /> },
    { path: 'Map', element: <Map /> },
    { path: 'email-broadcast', element: <EmailBroadcast /> },
    { path: 'kyc-admin-dashboard', element: <KYCAdminDashboard /> },
    { path: 'procurement', element: <ProcurementList /> },
    { path: 'procurement/create', element: <ProcurementEditCreate /> },
    { path: 'procurement/edit/:id', element: <ProcurementEditCreate /> },
    { path: 'procurement/approval/:id', element: <ProcurementApproval /> },
    { path: 'layout-requests', element: <LayoutRequestsList /> },
    { path: 'layout-requests/approval/:id', element: <LayoutRequestApproval /> },
    { path: 'procurement/layout-requests', element: <ProcurementLayoutRequests /> },
    { path: 'procurement/layout-requests/view/:id', element: <ProcurementLayoutRequestView /> },
    { path: 'procurement/ads-requests', element: <ProcurementAdsRequests /> },
    { path: 'payment-requests', element: <PaymentRequests /> },
    { path: 'LayoutOnboardingRequest/:qr', element: <LayoutOnboardingRequest /> },
    { path: 'ads/create', element: <AdsCreate /> },

  ]

  const NoSubscribe = [
    { path: 'subscribe', element: <SubscriptionPage /> },
    { path: 'subscribelogout', element: <SubscriptionLogout /> },
  ]

  const ProcurementNoSubscribe = [
    { path: 'procurement-subscribe', element: <ProcurementSubscriptionPage /> },
    { path: 'procurement-subscribelogout', element: <SubscriptionLogout /> },
  ]



  return useRoutes([
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: children,
    },
    {
      path: '/dashboard',
      element: (() => {
        if (account?.user_type === 'agent') {
          return account.subscribe ?
           <RequireAuth>
            <DashboardLayout />
          </RequireAuth> 
          : 
          <RequireAuth>
            <SubscriptionPage />
          </RequireAuth>
        }
        else if (account?.user_type?.toLowerCase() === 'procurement') {
          return account.subscribe ?
           <RequireAuth>
            <DashboardLayout />
          </RequireAuth> 
          : 
          <RequireAuth>
            <ProcurementSubscriptionPage />
          </RequireAuth>
        }
        else {
          return <RequireAuth>
            <DashboardLayout />
          </RequireAuth>;
        }
      })()
      ,
      children: account?.user_type === 'agent'
      ? !account.subscribe
        ? NoSubscribe
        : AgentChildren
      : account?.user_type?.toLowerCase() === 'procurement'
      ? !account.subscribe
        ? ProcurementNoSubscribe
        : AdminChildern
      : AdminChildern,
    
    },
  ]);
}

function RequireAuth({ children }) {
  let auth = useAuth();
  let location = useLocation();

  if (!auth) {
    toast.error('Please Login to Continue');
    return (
      <Navigate to="/login" state={{ location }} replace />
    );
  }

  return children;
}

function useAuth() {
  return sessionStorage.getItem('token');
}